$(window).on('load', function(){
  
    $('.store_map').each(function(){
        const RETAILER = $(this);
        initRetailer(RETAILER);
    });
});
function initRetailer(RETAILER){

        var stores;
        var storesHeader;
        var myMapCenter = {lat: 46.762823249467196, lng: -71.2104202932533};
        var section_id = $(this).data('section-id');
        var settings = JSON.parse($('[data-retailer-settings]').html());
        var distRadiusInput = 50; // Distance minimal
        var skeletonTemplate =  $('.store_sidebar').html();

        // Crée la google map
        var map = new google.maps.Map(RETAILER[0], {
            center: myMapCenter,
            zoom: 9,
            mapTypeControl: false,
            streetViewControl: false,
            styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
        });
        

        var geocoder = new google.maps.Geocoder();
        var infoWindow = new google.maps.InfoWindow();

        $('.store_search').on('click', searchStores);
        $(document).on('keypress',function(e) {
            if(e.which == 13) {
                searchStores();
            }
        });

        // Affiche les magasins près du code postal entré
        function searchStores(){
            $('.store_sidebar').text('').append(skeletonTemplate).scrollTop(0).fadeIn();
            var zipCode = $('#zip_code').val();
            geocoder.geocode({
              'address': zipCode,
              'region': 'ca'
              }, function (results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {

                          var closeStores = [];

                          stores.forEach(function(store){
                              var storeLat = APIField("latitude", store);
                              var storelong = APIField("longitude", store);
                              var dist = distance(results[0].geometry.location.lat(), results[0].geometry.location.lng(), storeLat, storelong, 'K');
                              store.push(dist)
                              store['distance'] = dist;
                              if(dist <= distRadiusInput){
                                  closeStores.push(store);
                              }
                          });

                          renderClosestStores(closeStores);
                          // Centre la map relativement à l'adresse entrée et selon un distance donnée.
                          var myLatLng = new google.maps.LatLng(results[0].geometry.location.lat(),results[0].geometry.location.lng());
                          var circleOptions = {
                              center: myLatLng,
                              fillOpacity: 0,
                              strokeOpacity:0,
                              map: map,
                              radius: distRadiusInput * 1000
                          };


                          var myCircle = new google.maps.Circle(circleOptions);
                          map.fitBounds(myCircle.getBounds());
                          map.setCenter(results[0].geometry.location);

                  } else {
                          alert(settings.no_result);
                  }
            });
        }

        $(document).on('click', '.store_info',  function(){
            var targetLat = $(this).data('target-lat');
            var targetLng = $(this).data('target-lng');
            var LatLng = new google.maps.LatLng(targetLat,targetLng);
            map.setCenter(LatLng);
            map.setZoom(14);
        });

        function persistPreferredLocation(e) {
            e.stopPropagation()

            localStorage.setItem('preferred_location_id', e.currentTarget.dataset.shopifyId)
            localStorage.setItem('preferred_location_searchable_only', e.currentTarget.dataset.searchableOnly)
            const event = new Event('set_preferred_location_id_event_by_map')
            window.dispatchEvent(event)
        }

        function bindAllPreflocCta(){
            document.querySelectorAll('.store_sidebar .prefloc_cta').forEach((cta) => {
                cta.addEventListener('click', persistPreferredLocation)
            })
        }

        // Render la sidebar des magasin a proximite
        
        function renderClosestStores(stores){
            
            stores.sort(function(a,b){
               if(a['distance'] > b['distance']){ return 1}
                if(a['distance'] < b['distance']){ return -1}
                  return 0;
            });

            var template = '';
            var directionLabel = settings.direction;

            stores.forEach(function(store){
                stores_details = !(typeof APIField("store_details", store) === "undefined" || APIField("store_details", store) === null) ? APIField("store_details", store) : false
                
                template += `
                <div class="store_info" data-target-lat="`+ APIField("latitude", store) +`" data-target-lng="`+ APIField("longitude", store) +`">
                <h3>` + APIField("entreprise", store) + `</h3>
                <p class="adr">` + APIField("adresse", store) + `</p>
                <p>` + APIField("extras", store) + `</p>
                <a class='directions_link' href='https://www.google.com/maps/search/?api=1&query=` + APIField("entreprise", store) + ' ' + APIField("adresse", store) + `,` + `' target='_blank'>`+ directionLabel +`</a>
                </div>
                `
                if (stores_details) {
                    store_id = stores_details.shopify_id === null ? stores_details.id : stores_details.shopify_id
                    store_searchable_only = stores_details.searchable_only

                    if (!(typeof store_id === "undefined" || typeof store_searchable_only === "undefined")) {
                        template += `
                        <div class="prefloc_cta"
                        data-shopify-id='${store_id}' data-searchable-only='${store_searchable_only}'
                        >${setPreferredStoreI18n}</div>
                        `;
                    }
                }
            });

            if(stores == ''){
                template = '<div class="store_info">'+settings.no_result+'</div>';
            }

            $('.store_sidebar').fadeOut(500, function(){
                $('.store_sidebar').text('').append(template).scrollTop(0).fadeIn();
                bindAllPreflocCta();
            });

        }

        // Ajoute les markers
        function markStore(storeInfo){
            var lat = APIField("latitude", storeInfo);
            var lng = APIField("longitude", storeInfo);

            var baseIcon = settings.marker;
            var customIcon = APIField("icone", storeInfo);

            var iconUrl = '';
            
            if(customIcon) {
                iconUrl = 'https://cdn.shopify.com/s/files/1/0733/6198/1625/files/' + customIcon;
            } else if(baseIcon) {
                iconUrl = baseIcon;
            }

            if(iconUrl) {

              var icon = {
                url: iconUrl,
                scaledSize: new google.maps.Size(55, 60),
                origin: new google.maps.Point(0,0),
                anchor: new google.maps.Point(27.5, 0)
              };

            }

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: icon
            });
            

            function showStoreInfo() {

                var directionLabel = settings.direction;
                var storeInfo = this.location;
                var title = "<span class='gm-info-title'><strong>" + APIField("entreprise", storeInfo) + "</strong></span>";
                var directions = "<a class='directions_link' href='https://www.google.com/maps/search/?api=1&query=" + APIField("entreprise", storeInfo) + ' ' + APIField("adresse", storeInfo) + "' target='_blank'>"+directionLabel+"</a>";

                var openingHours = APIField("opening hours", storeInfo);
                var openingHoursWrapper = "<div class='opening-hours' style='margin-top: 15px;'>" + openingHours + "</div>";

                if(openingHours) {
                  var resultOpeningHours = openingHoursWrapper.replace(/,/g, "<br>");
                } else {
                  var resultOpeningHours = "";
                }

                infoWindow.setContent([title, '<p class="gm-info-desc">'+APIField("adresse", storeInfo)+'</p>', directions, "", resultOpeningHours].join(""));
                infoWindow.open(map, this.marker);
            }

            marker.addListener(
                "click", showStoreInfo.bind({ location: storeInfo, marker: marker })
            );
        }

        // Fetch les stores depuis un fichier XLS
        var DOCID = settings.doc_id; // Cette variable correspond à l'ID du fichier google drive.

        var url = "https://sheets.googleapis.com/v4/spreadsheets/"+DOCID+"/values/Lieux?key="+settings.api_key;

        function fetchStores(){
            $.get(
                url
            ).then(function(result) {
                stores = result.values;
                storesHeader = stores[0].map(name => name.toLowerCase());
                
                stores.splice(0, 1);
                renderClosestStores(stores);
                setStores();
            });
        }
        fetchStores();

        // Attend d'avoir les stores avant de créer les markers

        function setStores(){
            if (typeof stores === "undefined" || stores === null) {
                setTimeout(function() {
                    setStores();
                }, 500);
                return;
            }
            stores.forEach(function(store){
                markStore(store);
            });
        }
        
        async function getStoresIdsFromApp(){
            app_url = "/apps/popshoesinventories/location_by_coordinates/all_locations.json"
            params = {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}), 
                body: JSON.stringify({locations: stores, keys: storesHeader})
            }
            await fetch(`/apps/popshoesinventories/location_by_coordinates/all_locations.json`, params)
            .then(response => response.json())
            .then(locations => {
                stores = locations;
                    storesHeader.push("store_details")
                    setStores();
                    renderClosestStores(stores);

            });
        }

        // Obtient les fields de la spreadsheet
        function APIField(name, obj) {
            var index = storesHeader.indexOf(name);
            if(obj[index]){
                return obj[index];
            }
            else{
                return "";
            }
        }


        // Calcule la distance entre 2 coordonnées (Lat et lng)
        function distance(lat1, lon1, lat2, lon2, unit) {
            if ((lat1 == lat2) && (lon1 == lon2)) {
                return 0;
            }
            else {
                var radlat1 = Math.PI * lat1/180;
                var radlat2 = Math.PI * lat2/180;
                var theta = lon1-lon2;
                var radtheta = Math.PI * theta/180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                    dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180/Math.PI;
                dist = dist * 60 * 1.1515;
                if (unit=="K") { dist = dist * 1.609344; }
                if (unit=="N") { dist = dist * 0.8684; }
                return dist;
            }
        }

        var rangeSlider = function(){
            var slider = $('.range-slider'),
            range = $('.range-slider__range'),
            value = $('.range-slider__value');

            slider.each(function(){

                value.each(function(){
                var value = $(this).prev().attr('value');
                    $(this).html(value + 'km');
                    distRadiusInput = parseInt($('.range-slider__range').val());
                });

                range.on('input', function(){
                    $(this).next(value).html(this.value + 'km');
                    distRadiusInput = parseInt($('.range-slider__range').val());
                });
            });
        };

        rangeSlider();
}
